import { getCookie } from "./utils/utils";

const initModalTimer = () => {
  const modalTimer = document.getElementById("modal-timer");

  if (modalTimer) {
    const modalTimerCookie = getCookie("modal_timer");

    if (modalTimerCookie) return;

    const timer = setTimeout(() => {
      modalTimer.classList.add("--active");
      document.body.classList.add("lock");
      document.cookie = "modal_timer=1; path=/; max-age=3600";

      clearTimeout(timer);
    }, 60 * 1000);
  }
};

const initModalFunctions = () => {
  const modalButtons = document.querySelectorAll<HTMLDivElement>("[data-modal]");
  const generalModal = document.getElementById("modal-general")!;
  const modals = document.querySelectorAll<HTMLDivElement>("[data-modal-window]");

  modalButtons.forEach((button) => {
    button.addEventListener("click", (event: PointerEvent) => {
      const { currentTarget } = event;
      const targetModal = (currentTarget as HTMLElement).dataset.modal;

      if (targetModal) {
        const findModal = [...modals].find((value) => value.dataset.modalWindow === targetModal);

        if (findModal !== undefined) {
          findModal.classList.add("--active");
        }
      } else {
        generalModal.classList.add("--active");
      }

      document.body.classList.add("lock");
    });
  });

  modals.forEach((modal) => {
    modal.addEventListener("click", (event: PointerEvent) => {
      const { target } = event;

      if ((target as HTMLElement).closest("[data-modal-close]")) {
        modal.classList.remove("--active");
        document.body.classList.remove("lock");
      }
    });
  });
};

// Соответствие хэша в URL и id модалки.
// Чтобы открывать модалку по ссылке вида orm-service.com/#getstarted
// просто добавь сюда новую пару: "хэш": "id-модалки".
const HASH_TO_MODAL: Record<string, string> = {
  getstarted: "modal-general",
  // "demo": "modal-request-demo",
};

const initModalHashLink = () => {
  const openFromHash = () => {
    const hash = window.location.hash.replace(/^#/, "");
    const modalId = HASH_TO_MODAL[hash];

    if (!modalId) return;

    const modal = document.getElementById(modalId);

    if (!modal) return;

    modal.classList.add("--active");
    document.body.classList.add("lock");
  };

  openFromHash();
  window.addEventListener("hashchange", openFromHash);
};

export const initModals = () => {
  initModalTimer();
  initModalFunctions();
  initModalHashLink();
};
